<template>
  <b-container fluid class="p-4">
    <h3 class="mb-4">ایجاد تخفیف</h3>

    <form-offer
        :submit="createOffer"
        :form="offer"
    />

  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import FormOffer from "./Form.vue";

export default {
  name: "Update",
  components: {FormOffer},
  data() {
    return {
      offer: {
        name: '',
        code: '',
        offerable_id: null,
        offerable_type: null,
        active_at: "2022-01-01 00:00:00",
        expire_at: "2025-01-01 00:00:00",
        price: 0,
        on_delivery_price: null,
        HowManyCanBeUsed: 1
      }
    };
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    createOffer() {
      console.log(this.offer, "update");
      this.$store.dispatch("Offer/createOffer", this.offer);
    },
  },
  async mounted() {
  },
};
</script>

<style scoped>
</style>